import script from "./BookingsReservationsDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingsReservationsDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./BookingsReservationsDetailPage.vue?vue&type=style&index=0&id=516b3049&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516b3049"]])

export default __exports__